import React from 'react';
import * as Ajax from '../services/index'
import './index.css'

class Home extends React.Component{
    constructor(props){
        super(props);
        this.state={
            list: [],
            isDelete: false,
        };
        document.getElementsByTagName("title")[0].innerText = '我的照片'
    }
    componentDidMount(){
        this.getInitData();
    }
    
    render(){
        let {isDelete,list} = this.state;
        return <div className="home">
            <div className="home_top">长按图片即可保存电子版至手机相册</div>
            {isDelete?<div className="home_top1">您的照片已超过7天自动删除，请在拍摄后重新加载页面</div>:
            <div className="home_top1">您还没有相关数据，请拍摄后查看</div>
            }
            <div className="home_icon"></div>
            <div className="home_list">
                {list.map((item,index)=>{
                    return <div key={item.photoId} className="home_list_item">
                        <img src={item.publicUrl} alt="照片"/>
                    </div>
                })}
            </div>
        </div>
    }

    getInitData () {
        Ajax.getPhotoList().then((res)=>{
            this.setState({
                list: res.list || res || [],
                isDelete: res.isDelete || false
            })
        })
    }
}

export default Home